import React from 'react';
import { Tab } from '@mui/material';
import DashboardPageLayout from 'src/frontend-common/components/DashboardPageLayout';
import { TabsWrapper, WhiteContainer } from 'src/style/common';
import { useGetCompaniesFromEmailQuery, useGetCompaniesFromAppKeyQuery } from 'src/redux/services/companiesAdmin';
import CompanyFromAppKey from 'src/pages/Utilities/components/companyFromAppKey';
import CompanyFromEmail from 'src/pages/Utilities/components/companyFromEmail';

const Utilities: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [email, setEmail] = React.useState<string>('');
  const [appKey, setAppKey] = React.useState<string>('');
  const [sendRequestEmail, setSendRequestEmail] = React.useState<boolean>(false);
  const [sendRequestAppKey, setSendRequestAppKey] = React.useState<boolean>(false);

  const handleTabChange = (_event: unknown, newValue: number) => {
    setActiveTab(newValue);
  };

  const { data: emailData, isLoading: emailIsLoading, isError: emailIsError } = useGetCompaniesFromEmailQuery({ email: email }, { skip: !sendRequestEmail });

  const {
    data: appKeyData,
    isLoading: appKeyIsLoading,
    isError: appKeyIsError,
  } = useGetCompaniesFromAppKeyQuery({ app_key: appKey }, { skip: !sendRequestAppKey });

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  return (
    <DashboardPageLayout title="Utilities">
      <>
        <TabsWrapper value={activeTab} indicatorColor="primary" onChange={handleTabChange} style={{ marginTop: 24 }}>
          <Tab label="Search by Email" {...a11yProps(0)} data-testid="email-tab" style={{ minWidth: 180 }} />
          <Tab label="Search by AppKey" {...a11yProps(1)} data-testid="app-key-tab" style={{ minWidth: 180 }} />
        </TabsWrapper>
        <WhiteContainer style={{ padding: 24 }}>
          {activeTab === 0 && (
            <CompanyFromEmail
              email={email}
              emailData={emailData}
              setEmail={setEmail}
              emailIsError={emailIsError}
              emailIsLoading={emailIsLoading}
              setSendRequestEmail={setSendRequestEmail}
            />
          )}
          {activeTab === 1 && (
            <CompanyFromAppKey
              appKey={appKey}
              setAppKey={setAppKey}
              appKeyData={appKeyData}
              appKeyIsError={appKeyIsError}
              appKeyIsLoading={appKeyIsLoading}
              setSendRequestAppKey={setSendRequestAppKey}
            />
          )}
        </WhiteContainer>
      </>
    </DashboardPageLayout>
  );
};

export default Utilities;
